import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-farmer-driver-listing', {
    mixins: [AppListing]
});